<template>
  <div>
    <h4 class="heading">
      ACCOUNT STATISTICS FOR
      {{ currentCircle.condition_type.toUpperCase() }} CIRCLE
    </h4>
    <div v-if="Object.keys(activity).length" class="count-cards" :style="{'margin-left':'-8px'}" >
      <div
        v-for="(act, i) in [
          'articles_count',
          
          'poll_taken_count',
          'hugs_given_count',
          'comments_count',
        ]"
        :key="i"
        class="count-card"
      >
        <div :class="act" class="count-icon" />
        <div :style="{ color: getPrimaryColor() }" class="count-num">
          {{ activity[act] }}
        </div>
        <div class="count-title">{{ act | humanize(false) }}</div>
      </div>
    </div>
    <h4 v-if="activity.hugs_given.length" class="heading">HUGS GIVEN</h4>
    <template>
      <div>
        <div class="row mt-4">
          <div
            class="col-md-6 col-lg-6 col-sm-12 col-xs-6 mb-5 "
            v-for="selfCircleMember in activity.hugs_given"
            :key="selfCircleMember.id"
          >
            <div class="claim-card">
              <div
                :style="
                  selfCircleMember.role === 'doctor'
                    ? { background: '#d6f6fb' }
                    : {}
                "
                class="user-name d-flex p-3"
              >
                <div
                  @click="viewProfile(selfCircleMember)"
                  class="bg-img d-block background-image"
                >
                  <img :src="selfCircleMember.url" alt="" />
                </div>
                <div
                  class="d-inline-block text-left ml-2 align-self-center overflow-hidden"
                >
                  <p class="m-0 bold-text text-truncate">
                    {{
                      selfCircleMember.role === "doctor"
                        ? selfCircleMember.first_name +
                          " " +
                          selfCircleMember.last_name
                        : selfCircleMember.display_name
                    }}
                  </p>
                  <p
                    :style="{ color: '#777' }"
                    v-if="selfCircleMember.location[0].city"
                    class="m-0 doc-loc text-truncate"
                  >
                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                    {{ selfCircleMember.location[0].city }},
                    {{ selfCircleMember.location[0].state }}
                  </p>
                  <p
                    class="m-0 recommendations hyper-link"
                    :style="{ color: getPrimaryColor(), cursor: 'default' }"
                  >
                    {{ selfCircleMember.no_of_members }} circle members
                  </p>
                  <div class="self-others">
                    <button
                      @click="addMemberToCircle(selfCircleMember)"
                      class="dovemed-button font-white primary-button"
                      :style="{
                        background: `${
                          selfCircleMember.on_circle
                            ? currentCircle.color_code2
                            : currentCircle.color_code
                        }`,
                        'pointer-events': selfCircleMember.on_circle ? 'none' : 'all'
                        
                      }"
                    >
                      {{
                        selfCircleMember.on_circle
                          ? "In your circle"
                          : "ADD TO CIRCLE"
                      }}
                      <i
                        class="fa fa-check font-white"
                        aria-hidden="true"
                        v-if="selfCircleMember.on_circle"
                      >
                      </i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template>
      <h4 v-if="activity.poll_taken_count > 0" class="heading">Poll Taken</h4>
      <div v-if="activity.poll_taken_count > 0" >
        <div v-for="poll in activity.polls_taken" :key="poll.id" class="mt-4"   >
          <PollCard :pollData='poll' />
        </div>
      </div>
      
    </template>
    <template>
      <h4 v-if="!activity.read_articles" class="heading mt-4">Articles Read</h4>
     <div v-if="activity.read_articles" >
        <div v-for="article in activity.read_articles" :key="article.id" class="mt-4" >
        <ArticleCard :articleData='article' />
      </div>
     </div>
     
    </template>
  </div>
</template>

  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import PollCard from '../home/resources/previews/PollCard'
import ArticleCard from "../home/resources/previews/ArticleCard"

const UserRepository = RepositoryFactory.get("user");
const ResourceRepository = RepositoryFactory.get("resource");

export default {
  name: "YourActivity",
  data() {
    return {
      activity: {},
    };
  },
  components: {
    PollCard,
    ArticleCard
    
  },
  mounted() {
    this.init();
    console.log('scrolling...');
    window.scrollTo(0, 0);
  },
  methods: {
    init() {
      this.setAppLoaderStatus(true);
      UserRepository.getActivity(this.currentCircle.id)
        .then((res) => {
          if (res.data) {
            this.activity = res.data.data;
            console.log(this.activity,"activity")
            console.log(this.activity)
            
            this.setAppLoaderStatus(false);
          }
          this.setAppLoaderStatus(false);
        })
        .catch((err) => {
          this.setAppLoaderStatus(false);
        })
        .catch((err) => console.error(err));
    },

    /**
     * Add Member to Circle
     */
    addMemberToCircle(user) {
      UserRepository.addToCircle(user, this.currentCircle.id)
        .then((res) => {
          this.init();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    /**
     * View other user profile
     */
    viewProfile(user) {
      if (user.id === this.authUser.user.id) {
        this.routeToAuthProfile(this.authUser.user.role);
      } else {
        UserRepository.getOtherUserProfile(user, this.currentCircle.id)
          .then((res) => {
            const data = {
              ...res.data.data.user_info,
              no_of_members: res.data.data.no_of_members,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
              recommendations: res.data.data.no_of_recommendations,
              recommend: res.data.data.recommend,
            };
            this.$store.commit("User/setViewUser", { data });
            switch (user.role) {
              case "doctor":
                this.$router.push({
                  name: "ViewDoctorUpdates",
                  params: { id: user.id },
                });
                break;
              case "patient":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.id },
                });
                break;
              case "caregiver":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.id, role: 'caregiver' },
                });
                break;
              case "advocate":
                this.$router.push({
                  name: "ViewAdvocateUpdates",
                  params: { id: user.id },
                });
                break;
              default:
                break;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
      // localStorage.setItem('__ou', JSON.stringify(data))
    },
  },
  filters: {
    humanize: function (value, capitalize = true) {
      if (!value) return "";
      else value = value.replace("_count", "");
      return capitalize
        ? value
            .toLowerCase()
            .split("_")
            .map((e) => e.toUpperCase())
            .join(" ")
        : value
            .toLowerCase()
            .split("_")
            .map((e) => e.charAt(0).toUpperCase() + e.substring(1))
            .join(" ");
    },
  },
};
</script>

<style lang="scss" scoped>
.heading {
  height: 15px;
  margin: 20px auto;
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  padding-left: 12px;
}
.count-cards {
  display: flex;
  flex-wrap: wrap;
  .count-card {
    width: 144px;
    margin: 10px;
    background: white;
    border-radius: 20px;
    border: 1px solid lightgray;
    padding: 20px;
    text-align: center;
    .count-icon {
    }
    .count-num {
      font-size: 24px;
      font-weight: bold;
      margin: 10px auto;
    }
    .count-title {
      font-size: 16px;
    }
  }
}
.self-others {
  display: flex;
  padding: 10px 0;
  button {
    padding: 10px 20px;
    // font-size: 12px;
  }
}
.count-icon {
  width: 50px;
  height: 50px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin: auto;
}
.articles_count {
  background-image: url("../../assets/acset/Articles.svg");
}
.quiz_taken_count {
  background-image: url("../../assets/acset/Quizzes.svg");
}
.poll_taken_count {
  background-image: url("../../assets/acset/Polls.svg");
}
.hugs_given_count {
  background-image: url("../../assets/acset/Hugs.svg");
}
.comments_count {
  background-image: url("../../assets/acset/Comments.svg");
}
</style>



// WEBPACK FOOTER //
// src/components/account/YourActivity.vue